export const CRUD_PATH = `log`
